
<app-form-number-child [item]="item" [submitted]="submitted" [itemRequired]="item.required" [itemName]="item.name" [itemLabel]="item.label"
  [itemMin]="item.min" [itemMax]="item.max" [itemPlaceholder]="item.placeholder">
</app-form-number-child>

